import { render } from "@/components/pages/individualWorkSupport/requirement071/Requirement071.html?vue&type=template&id=233d0a99&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement071/Requirement071.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement071/Requirement071.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement071/Requirement071.scss?vue&type=style&index=0&id=233d0a99&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233d0a99"]])

export default __exports__